export const environment = {
  SERVER: 'https://bi-stg.plataformabi.wizerg.dev',
  //SERVER: 'https://tgcshdsn-3000.usw3.devtunnels.ms',
  VERSION: '1.2.3',
  DEFAULT_PAGE_TO_LOAD: '/auth/event',
  AFTER_REGISTER_REDIRECT_TO: 'https://demo.bizgto.com/'
};
